module.exports = __webpack_public_path__ + "static/media/yuuki-asuna-icon.b50c23f9.png";